module.exports = __webpack_public_path__ + "img/image8.f1f35ee1.png";